import { Fragment } from 'react';
import { Contact } from '../../../components/contact';
import { Faq } from '../../../components/faq';

export function ContactPage() {
	return (
		<Fragment>
			<Contact />
			<Faq />
		</Fragment>
	);
}
